import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import {
  HostListener,
  Component,
  ViewChild,
  OnInit,
  inject,
  ChangeDetectorRef,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { Injector } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { BasePage } from '../services/base-page';
import { idNameItem, jkRestReturn, OpenWinLoadOption, PageKind, uiModeList, UiModeType } from '../services/jkInterface';
import { JkEntityV2 } from '../services/jkEntityV2';
import { TitlebarComponent } from './titlebar/titlebar.component';
import { HomeHeaderComponent } from './home-header/home-header.component';
import { GridInitOption } from '../services/ag-grid.service';
import { JkpowerService } from '../services/jkpower.service';
import { AppPage, iif, jkAlert, jkRestReturnClass, newOpenwinLoadOption, searchById } from '../services/jkClass';
import { OrmService } from '../services/jkOrm';
import { login } from '../services/jkUser';
import { isNil, jkLib } from '../services/jkCommon';
import { JkaboutComponent } from './jkabout/jkabout.component';
import { jkGlb, JkGlbClass } from '../services/jkglb';
import { PageService } from '../services/page.service';
import { SweetAlertIcon } from 'sweetalert2';
import { entityState } from '../services/jkEntityTypes';
import { HttpClient } from '@angular/common/http';
import { JkBaseFormType } from './JkBaseFormType';

@Component({
  standalone: true,
  selector: 'app-jkBaseForm',
  template: '',
  providers: [MatDialogRef, HttpClient] /*, MatSnackBar*/,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule],
})
export class jkBaseForm extends BasePage implements OnInit, JkBaseFormType {
  PageKind = PageKind; // 不要remark.給 html 用
  private _pageKind: PageKind = PageKind.master;// 建檔分類
  get pageKind(): PageKind {
    return this._pageKind;
  }
  set pageKind(value: PageKind) {
    this._pageKind = value;
  }
  uiMode: UiModeType = UiModeType.dialog;  //'dialog' | 'tab' = 'dialog'; // | 'page' | 'popup'  | 'none'
  page: PageService = inject(PageService);
  /*
  get state(): entityState {
    return entityState.dsBrowse;
  }*/

  titlebarCom!: TitlebarComponent;
  // TODO: Skipped for migration because:
  //  This query overrides a field from a superclass, while the superclass field
  //  is not migrated.
  // TODO: Skipped for migration because:
  //  This query overrides a field from a superclass, while the superclass field
  //  is not migrated.
  // TODO: Skipped for migration because:
  //  This query overrides a field from a superclass, while the superclass field
  //  is not migrated.
  // TODO: Skipped for migration because:
  //  This query overrides a field from a superclass, while the superclass field
  //  is not migrated.
  @ViewChild('masterTabGroup') masterTabGroupCom!: MatTabGroup;
  homeHeader!: HomeHeaderComponent;
  get masterTabGroupIndex(): number | null {
    if (!this.masterTabGroupCom) return null;
    return this.masterTabGroupCom.selectedIndex;
  }
  set masterTabGroupIndex(value: number) {
    if (!this.masterTabGroupCom) return;
    this.masterTabGroupCom.selectedIndex = value!;
  }
  onMasterTabChange($event: MatTabChangeEvent) { }
  gridInitOpt: GridInitOption;
  isChild: boolean = false;
  isCheckPower: boolean = true;

  requests: string[] = [];
  token: string = '';
  logMessage: string = '';
  power: JkpowerService;  // ^_^ jackie 20250223 remark
  openwinLoadOpts: OpenWinLoadOption[] = [];
  uiModeList: idNameItem[] = uiModeList;
  http: HttpClient;
  //public jkGlb: JkGlbClass = inject(JkGlbClass);
  public orm: OrmService = jkGlb.orm; //inject(OrmService);
  constructor(injector: Injector = inject(Injector)) {

    super(injector);
    //this.programId = this.programId.toLowerCase();
    //this.setInjector();
    this.login = login;
    this.http = injector.get(HttpClient);
    this.orm.init(this.http);
    this.power = new JkpowerService();
    /*this.doUIEdit.bind(this);
    this.doUIPost.bind(this);
    this.doUIInsert.bind(this);
    this.doUIDelete.bind(this);
    this.doUIQuery.bind(this);
    this.doUICancel.bind(this);
    this.doUIRefresh.bind(this);*/
    this.gridInitOpt = {
      //pageType: PageType.base,
      pageKind: PageKind.master,
      programId: this.programId,
      sortField: '',
      sort: 'asc', // gridSortType.asc,
      defaultSort: null,
    };
  }

  addOpenwinLoadOption(
    mainTable: string,
    item: string,
    type: string,
    param: any[],
    list: any
  ) {
    let n = newOpenwinLoadOption(mainTable, item, type, param, list);
    this.openwinLoadOpts.push(n);
  }

  doUIEdit(params?: any) {
    this.power.checkPower(this.programId, this.login, 'edit');
    this.ret.clear(true);
    this.onBeforeEdit(params, this.ret);
    if (!this.ret.result) return;
    this.onEditting(params, this.ret);
    if (!this.ret.result) return;
    this.onAfterEdit(params, this.ret);
  }
  onEditting(params: any, ret: jkRestReturn) { }

  async doUIDelete(params?: any): Promise<boolean> {
    this.power.checkPower(this.programId, this.login, 'delete');
    let bool = false;
    let ret2 = new jkRestReturnClass();
    ret2.clear(true);
    this.onBeforeDelete(params, ret2);
    if (!ret2.result) return false;
    await this.onDeleting(params, ret2);
    bool = ret2.result;
    if (!bool) return false;
    this.onAfterDelete(params, ret2);
    bool = ret2.result;
    return bool;
  }
  async onDeleting(params: any, ret: jkRestReturn) {

  }
  doUIInsert(params?: any) {
    this.power.checkPower(this.programId, this.login, 'insert');
    /* before after event 由jkEntityV2 處理
    this.ret.clear(true);
    this.onBeforeInsert(params,this.ret);
    if(!this.ret.result) return;
    this.onInserting(params,this.ret);
    if(!this.ret.result) return;
    this.onAfterInsert(params,this.ret);
    */
  }
  async doEditAndSave($event: any): Promise<boolean> {
    return true;
  }
  doUIGridEdit($event: any) { }

  onInserting(params: any, ret: jkRestReturn) { }
  async doUIPost(params?: any): Promise<boolean> {
    let bool = true;
    this.ret.clear(true);
    this.onBeforePost(params, this.ret);
    if (!this.ret.result) return false;
    this.onPosting(params, this.ret);
    if (!this.ret.result) return false;
    this.onAfterPost(params, this.ret);
    return bool;
  }
  onPosting(params: any, ret: jkRestReturn) { }
  doUIQuery(params?: any) {
    this.power.checkPower(this.programId, this.login, 'query');
    this.ret.clear(true);
    this.onBeforeQuery(params, this.ret);
    if (!this.ret.result) return;
    this.onQuerying(params, this.ret);
    if (!this.ret.result) return;
    this.onAfterQuery(params, this.ret);
  }
  onQuerying(params: any, ret: jkRestReturn) { }

  doUICancel(params?: any): boolean {
    let bool = true;
    this.ret.clear(true);
    this.onBeforeCancel(params, this.ret);
    if (!this.ret.result) return false;
    this.onCalceling(params, this.ret);
    if (!this.ret.result) return false;
    this.onAfterCancel(params, this.ret);
    return bool;
  }
  onCalceling(params: any, ret: jkRestReturn) { }
  doUIRefresh(state: entityState, item: any) { }
  doRefresh() {
    this.onBeforeRefresh(undefined, this.ret);
  }
  onCellClicked($event: any) { }

  // dataService event begin --------------------
  setEntityEvent(ent: JkEntityV2) {
    if (!ent) {
      jkAlert('setEntityEvent ent is null!');
      return;
    }
    ent.cbUIPost = this.doUIPost.bind(this);
    ent.cbUICancel = this.doUICancel.bind(this);

    ent.cbStateChanged = this.onStateChanged.bind(this);

    ent.onAfterCancel = this.onAfterCancel.bind(this);
    ent.onAfterClose = this.onAfterClose.bind(this);
    ent.onAfterDelete = this.onAfterDelete.bind(this);
    ent.onAfterEdit = this.onAfterEdit.bind(this);
    ent.onAfterInsert = this.onAfterInsert.bind(this);
    ent.onAfterOpen = this.onAfterOpen.bind(this);
    ent.onAfterPost = this.onAfterPost.bind(this);
    ent.onAfterQuery = this.onAfterQuery.bind(this);
    ent.onAfterRefresh = this.onAfterRefresh.bind(this);
    ent.onAfterScroll = this.onAfterScroll.bind(this);
    ent.onBeforeCancel = this.onBeforeCancel.bind(this);
    ent.onBeforeClose = this.onBeforeClose.bind(this);
    ent.onBeforeDelete = this.onBeforeDelete.bind(this);
    ent.onBeforeEdit = this.onBeforeEdit.bind(this);
    ent.onBeforeInsert = this.onBeforeInsert.bind(this);
    ent.onBeforeOpen = this.onBeforeOpen.bind(this);
    ent.onBeforePost = this.onBeforePost.bind(this);
    ent.onBeforeQuery = this.onBeforeQuery.bind(this);
    ent.onBeforeRefresh = this.onBeforeRefresh.bind(this);
    ent.onBeforeScroll = this.onBeforeScroll.bind(this);
    //console.log(ent.tableName+' setEntityEvent ok');
  }
  onStateChanged(state: entityState) { }
  onAfterCancel(item: any, ret: jkRestReturn) { }
  onAfterClose(item: any, ret: jkRestReturn) { }
  onAfterDelete(item: any, ret: jkRestReturn) { }
  onAfterEdit(item: any, ret: jkRestReturn) { }
  onAfterInsert(item: any, ret: jkRestReturn) { }
  onAfterOpen(item: any, ret: jkRestReturn) { }
  async onAfterPost(item: any, ret: jkRestReturn) { }
  onAfterQuery(item: any, ret: jkRestReturn) { }
  onAfterRefresh(item: any, ret: jkRestReturn) { }
  onAfterScroll(item: any, ret: jkRestReturn) { }
  onBeforeCancel(item: any, ret: jkRestReturn) { }
  onBeforeClose(item: any, ret: jkRestReturn) { }
  onBeforeDelete(item: any, ret: jkRestReturn) { }
  onBeforeEdit(item: any, ret: jkRestReturn) { }
  onBeforeInsert(item: any, ret: jkRestReturn) { }
  onBeforeOpen(item: any, ret: jkRestReturn) { }
  onBeforePost(item: any, ret: jkRestReturn) { }
  onBeforeQuery(item: any, ret: jkRestReturn) { }
  onBeforeRefresh(item: any, ret: jkRestReturn) { }
  onBeforeScroll(item: any, ret: jkRestReturn) { }

  // dataService event end --------------------
  ngOnInit() {
    this.init2();
  }
  async ngAfterViewInit(): Promise<void> {
    this.setFormOpt2(); //###
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize($event?: any) {
  }
  get myGridWidth(): number {
    return this.screenWidth;
  }


  // setFormOpt2(isCheckPower: boolean = false, title: string = '') {
  async setFormOpt2(title: string = ''): Promise<void> {
    this.appPages = jkGlb.pages;
    if (isNil(this.pageKind)) {//
      alert('XXX ' + this.programId + ' setFormOpt2 pageKind 未設定!');
      return;
    }
    //let appPages = this.jkGlb.pages;
    if ((this.pageKind === PageKind.detail) || (this.pageKind === PageKind.foot)
      || (this.pageKind === PageKind.hand))
      return;

    let myAppPage = searchById(this.appPages, this.programId);
    if (myAppPage) {
      if (title === '') title = myAppPage.title;
      //this.programId = this.myAppPage.id.toLowerCase();
      this.icon = myAppPage.icon;
      if (myAppPage.url) this.url = myAppPage.url;
      this.isCheckPower = myAppPage.isCheckPower;
    } else {
      alert(
        'setFormOpt2 程式錯誤! appPages id:' +
        this.programId +
        '找不到 時必須設title!'
      );

    }
    this.title = title;


    if (this.url === '') this.url = '/' + this.programId;


    let isPower = true;
    const isBill = (this.pageKind === PageKind.master) || (this.pageKind === PageKind.bill);
    if (this.isCheckPower && myAppPage && isBill)
      isPower = await this.power.setPower(this.programId, this.login, this.ret, myAppPage.isCheckPower)
    else {
      isPower = await this.power.setPower(this.programId, this.login, this.ret, false);
    }
    if (!isPower) {
      jkAlert('無權限進入此頁!');
      // 回上頁
      this.location.back();
      return;
    };

    this.init();
  }
  appPages: AppPage[] = [];
  init() {
    if (!this.programId) {
      jkAlert('程式錯誤! init setFormOpt 未執行!');
    }
    this.programId = this.programId.toLowerCase();

    if (!this.login.isLogin) {
      this.navigateTo('/login-form');
      return;
    }
    if (!this.isChild) {
      setTimeout(() => {
        if (this.title.indexOf('(') < 0) {
          document.title = this.title + '(' + this.programId + ')';
        } else {
          document.title = this.title;
        }
      });
    }
    try {
      this.init2();
    } catch (error: any) {
      jkAlert('init2 catch error!' + error.message);
    }
  }

  init2() {
    if (!this.programId) {
      jkAlert('程式錯誤! setFormOpt 未執行!');
    };
  }
  beforeSetTitlebar() { }
  initTabGroup() {
    if (this.masterTabGroupCom) {
      this.masterTabGroupCom.animationDuration = '0ms';
      this.masterTabGroupCom.stretchTabs = false;
      this.masterTabGroupCom.dynamicHeight = false;

      // mat-align-tabs="start"
    }
  }
  titleOptionsClick(e: string) {
    if (e === 'add') {
      this.doUIInsert(undefined);
    }
    if (e === 'search') {
      this.doUIQuery();
    }
    if (e === 'refresh') {
      this.doUIRefresh(entityState.dsBrowse, undefined);
    }
    if (e === 'arrow_upward') {
      //this.listScrollTop();
    }
  }

  private setTitlebar() {
    this.beforeSetTitlebar();
    if (this.titlebarCom) {
      //this.titlebar.setTitle(this.title);
      setTimeout(() => {
        //this.titlebarCom.page = this;
        this.titlebarCom.label.set(this.title);
        //this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
        this.appRef.tick();  // 不用 cdr 了
      }, 1);
    }
  }
  checkAllInit(form: any): boolean {
    this.setTitlebar();

    if (!(form as jkBaseForm).titlebarCom) {

      return false;
    }
    return true;
  }

  override async goHome() {
    /* if (this.state !== entityState.dsBrowse) {
      this.showAlert('請先取消或儲存資料');
      return;
    }*/
    await super.goHome();
  }
  override goBack(): void {
    /*if (this.state !== entityState.dsBrowse) {
      this.showAlert('請先取消或儲存資料');
      return;
    }*/
    super.goBack();
  }

  logRequest(method: string, url: string, data: any /*object*/): void {
    const args = Object.keys(data || {})
      .map((key) => key + '=' + data[key])
      .join(' ');

    //const time1 = formatDate(new Date(), 'HH:mm:ss');
    const time1 = jkLib.nowTime8();
    try {
      this.requests.unshift(
        [time1, method, url.slice(url.length), args].join(' ')
      );
    } catch (error: any) { }
  }

  clearRequests() {
    this.requests = [];
  }
  doShowItemList(itemList: any) {
    this.doTextArea(JSON.stringify(itemList), this.title);
  }
  doShowJkRestResult(ret: jkRestReturn, title: string = '') {
    if (ret.result) {
      let msg = ret.message;
      this.doTextArea(msg, iif(title !== '', title, '執行成功'));
    } else {
      let msg = ret.message + ' ' + ret.getResultError();
      this.doTextArea(msg, iif(title !== '', title, '執行錯誤'));
    }
  }
  getLookup() {
    this.orm.loadOpenwinOptions(this.openwinLoadOpts);
  }
  openHelpWindow(url: string) {
    window.open(url, '_blank');
  }
  readonly onFormReady = output<any>();
  doFormReady($e: any, pageKind: PageKind) {

  };
  doComReady($e: any, comName: string) {
    if (comName === 'titlebar') {
      this.titlebarCom = $e;
      this.titlebarCom.label.set(this.title);
      this.titlebarCom.titleOptionsClick = this.titleOptionsClick.bind(this);
    }
    if (comName === 'home-head')
      this.homeHeader = $e;

  }
  doTextArea(
    content: string,
    title: string
  ) {
    let width = '80%';
    let height = '80%';
    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: title, content: content, result: true },
    });
    return dialogRef.afterClosed();
  };

  doShowJson(
    //injector: Injector,
    jsonObj: any,
  ) {
    let width = '80%';
    let height = '80%';

    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: 'JSON', content: '', jsonObj: jsonObj, result: true },
    });
    return dialogRef.afterClosed();
  };

  doShowJsonAndTextArea(
    title: string,
    content: string,
    jsonObj: any
  ) {
    let width = '80%';
    let height = '80%';

    const dialogRef = this.dialog.open(JkaboutComponent, {
      width: width,
      height: height,
      data: { title: title, content: content, jsonObj: jsonObj, result: true },
    });
    return dialogRef.afterClosed();
  };
  override async showMessage(msg: string, type?: SweetAlertIcon): Promise<void> {
    return await this.page.showMessage(msg);
  }
  setMasterHaveDetail(haveDetail: boolean) {
    // 給子孫覆寫. jkSingle,jkBatch,jkQuery...
  }
}


